import { render, staticRenderFns } from "./ProductCategoryPagination.vue?vue&type=template&id=8c549b3c"
import script from "./ProductCategoryPagination.vue?vue&type=script&lang=js"
export * from "./ProductCategoryPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowLeftIcon: require('/vercel/path0/components/icons/ArrowLeftIcon.vue').default})
